import React, { useRef, useState, useEffect} from 'react';
import "./projects.scss";
import { Container, Row, Col, Button} from 'react-bootstrap';
import GlitchLines from '../../components/glitchLines/glitchLines';
import LetsTalk from '../../components/letsTalk/letsTalk';
import { useAnimationContext } from '../../AnimationContext';
import { FaSearch, FaSadTear } from 'react-icons/fa';
import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';
import gsap from 'gsap';
import Flip from 'gsap/src/Flip';

gsap.registerPlugin(Flip);

const projectsItems = [

    [
        "Category",
        "Title",
        "Description",
        "Image"
    ],
    [
        "Branding",
        "Consectetuer \nAdipiscing",
        "Nullam id dolor id nibh ultricies vehicula ut id elit. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Donec id elit non mi porta gravida at eget metus.",
        "./img/Peanuts.png"
    ],
    [
        "Illustrations",
        "Lorem Ipsum",
        "Nullam id dolor id nibh ultricies vehicula ut id elit. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Donec id elit non mi porta gravida at eget metus.",
        "./img/Vernie.png"
    ],
    [
        "Print Graphics",
        "Finding\nContentment",
        "Nullam id dolor id nibh ultricies vehicula ut id elit",
        "./img/Print.png"
    ],
    [
        "Branding",
        "Sixty Seven\nCafe",
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.",
        "./img/SixtySeven.png"
    ],
    [
        "Branding",
        "Consectetuer \nAdipiscing",
        "Nullam id dolor id nibh ultricies vehicula ut id elit. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Donec id elit non mi porta gravida at eget metus.",
        "./img/Peanuts.png"
    ],
    [
        "Print Graphics",
        "Finding\nContentment",
        "Nullam id dolor id nibh ultricies vehicula ut id elit",
        "./img/Vernie.png"
    ],
    [
        "Branding",
        "Sixty Seven\nCafe",
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.",
        "./img/SixtySeven.png"
    ],
    [
        "Web Design",
        "Africa Herald\r\nPublishing House",
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut Lorem ipsum dolor sit amet.",
        "./img/ahph.png"
    ],
    [
        "Branding",
        "Consectetuer \nAdipiscing",
        "Nullam id dolor id nibh ultricies vehicula ut id elit. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Donec id elit non mi porta gravida at eget metus.",
        "./img/Peanuts.png"
    ],
    [
        "Illustrations",
        "Lorem Ipsum",
        "Nullam id dolor id nibh ultricies vehicula ut id elit. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Donec id elit non mi porta gravida at eget metus.",
        "./img/Print.png",
    ],
    [
        "Web Design",
        "Africa Herald\r\nPublishing House",
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut Lorem ipsum dolor sit amet.",
        "./img/ahph.png"
    ]
];

const Projects = () => {
    const { isPreloaderComplete } = useAnimationContext();

    //for glitch lines
    const parentRef = useRef(null);

    //for isotope
  const [isotope, setIsotope] = useState(null);
  const [filterKey, setFilterKey] = useState('*');
  const [qsRegex, setQsRegex] = useState(null);
  const [selectedButton, setSelectedButton] = useState('*');



  // initialize an Isotope object with configs
    useEffect(() => {
        const grid = document.querySelector('.grid');
        imagesLoaded(grid, () => {
            setIsotope(
                new Isotope(grid, {
                    itemSelector: '.grid-item',
                    layoutMode: 'masonry',
                    masonry: {
                        columnWidth: '.grid-sizer'
                    }
                })
            );
        });
    }, []);
    
    // handle filter changes
    useEffect(() => {
        if (isotope) {
            isotope.arrange({
                filter: function (itemElem) {
                    const filterResult = filterKey === '*' || itemElem.classList.contains(filterKey);
                    const searchResult = qsRegex ? itemElem.textContent.match(qsRegex) : true;
                    return filterResult && searchResult;
                }
            });
        }
    }, [isotope, filterKey, qsRegex]);

    const handleButtonClick = (filter) => {
        setFilterKey(filter);
        setSelectedButton(filter);
    };

    const handleSearch = (event) => {
        const searchValue = event.target.value;
        setQsRegex(new RegExp(searchValue, 'gi'));
    };

      //for flip
      const [activeItem, setActiveItem] = useState(null);

      const showDetails = (item) => {
          if (activeItem) {
              return hideDetails();
          }
      
          const details = document.querySelector('.detail');
          const detailContent = document.querySelector('.content');
          const detailImage = document.querySelector('.detail img');
          const detailTitle = document.querySelector('.detail .title');
          const detailDescription = document.querySelector('.detail .description');
      
          const onLoad = () => {
              console.log('Image loaded, starting Flip animation');
              Flip.fit(details, item, { scale: true, fitChild: detailImage });
              const state = Flip.getState(details);
              gsap.set(details, { clearProps: true });
              gsap.set(details, { xPercent: -50, top: "50%", yPercent: -50, visibility: "visible", overflow: "hidden" });
      
              Flip.from(state, {
                  duration: 0.5,
                  ease: "power2.inOut",
                  scale: true,
                  onComplete: () => gsap.set(details, { overflow: "auto" })
              }).to(detailContent, { yPercent: 0 }, 0.2);
      
              detailImage.removeEventListener("load", onLoad);
              document.addEventListener('click', hideDetails);
          };
      
          // Set the content before the image load event
          detailTitle.innerText = item.querySelector('.title').innerText;
          detailDescription.innerText = item.querySelector('.description').innerText;
      
          // Add load event listener before setting the src
          detailImage.addEventListener("load", onLoad);
          detailImage.src = item.querySelector('img').src;
      
          console.log('showDetails called for item:', item);
      
          gsap.to(".grid-item", { opacity: 0.3, stagger: { amount: 0.7, from: Array.from(document.querySelectorAll('.grid-item')).indexOf(item), grid: "auto" } }).kill(item);
          gsap.to(".portfolioGrid", { backgroundColor: "#fff", duration: 1, delay: 0.3 });
          setActiveItem(item);
          console.log('activeItem set to:', activeItem);
          console.log('item is', item);
      };

      const hideDetails = () => {
          document.removeEventListener('click', hideDetails);
          const details = document.querySelector('.detail');
          const detailContent = document.querySelector('.content');
          const detailImage = document.querySelector('.detail img');
      
          if (!details || !activeItem) {
              console.error('Details or activeItem is null:', { details, activeItem });
              return;
          }
      
          gsap.set(details, { overflow: "hidden" });
      
          const state = Flip.getState(details);
      
          Flip.fit(details, activeItem, { scale: true, fitChild: detailImage });
      
          const tl = gsap.timeline();
          tl.set(details, { overflow: "hidden" })
              .to(detailContent, { yPercent: -100 })
              .to(".grid-item", { opacity: 1, stagger: { amount: 0.7, from: Array.from(document.querySelectorAll('.grid-item')).indexOf(activeItem), grid: "auto" } })
              .to(".portfolioGrid", { backgroundColor: "#fff" }, "<");
      
          Flip.from(state, {
              scale: true,
              duration: 0.5,
              delay: 0.25,
              onInterrupt: () => tl.kill()
          }).set(details, { visibility: "hidden" });
      
          details.removeEventListener('click', hideDetails); // Remove event listener here
          setActiveItem(null);
      
          console.log('hideDetails called');
      };

    const renderProjects = () => {
        return projectsItems.slice(1).map((item, index) => (
            
            <div 
                key={index} 
                className={`grid-item ${item[0].toLowerCase().replace(' ', '-')}`} 
                style={{ backgroundImage: `url(${item[3]})`, backgroundSize: 'contain', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat' }}
                onClick={(e) => showDetails(e.currentTarget)}
            >
                <img src={item[3]} alt={item[1]} />
                <div className='d-none'>
                    <h5 className="category" >{item[0]}</h5>
                    <h3 className="title" >{item[1]}</h3>
                    <p className="description" >{item[2]}</p>
                </div>
            </div>
        ));
    };

    return (
        <div ref={parentRef}>
        <GlitchLines parentRef={parentRef} />
        <svg className="glitchLines">
            <defs>
                <filter id="noise">
                    <feTurbulence type="fractalNoise" baseFrequency="0.05" numOctaves="5" result="noise" seed="10" />
                    <feDisplacementMap in="SourceGraphic" in2="noise" scale="10" xChannelSelector="R" yChannelSelector="G" />
                </filter>
            </defs>
            <g className="d-none d-lg-block">
            <line x1="70%" y1="0" x2="100%" y2="25%" />
            <line x1="60%" y1="100%" x2="100%" y2="2%" />
            </g>
            <g className="d-lg-none">
            <line x1="0" y1="61%" x2="100%" y2="98%" />
            <line x1="0" y1="72%" x2="100%" y2="54%" />
            <line x1="0" y1="44%" x2="100%" y2="1%" />
            </g>
            
        </svg>
        <section id='pageProjects'>
            <Container fluid>
                <Row className='projectsSticky'>
                    <Col md={6} className="d-flex flex-column align-items-center align-items-md-start">
                        <h1 className={`headerText ${isPreloaderComplete ? 'headerTextHighlight' : ''}`}>My Projects</h1>
                        <h1 className={`headerText ${isPreloaderComplete ? 'headerTextHighlight' : ''}`} style={{marginTop: "-22px"}}>Portfolio</h1>
                    </Col>
                    <Col md={6} className="d-flex flex-column align-items-end justify-content-center ">
                        <div className="search-wrapper d-none d-md-block">
                            <input className="search-input" type="search" id="quicksearch" placeholder="Enter keywords to search" onChange={handleSearch}/>
                            <FaSearch className="search-icon" />
                        </div>
                        <Col xs={12} className="d-flex flex-row justify-content-center justify-content-lg-around mb-3 button-group" id="filters">
                            <Button type="button" className={`btnFilter ${selectedButton === '*' ? 'is-selected' : ''}`} onClick={() => handleButtonClick('*')}>All</Button>
                            <Button type="button" className={`btnFilter ${selectedButton === 'web-design' ? 'is-selected' : ''}`} onClick={() => handleButtonClick('web-design')}>Web UI/UX</Button>
                            <Button type="button" className={`btnFilter ${selectedButton === 'branding' ? 'is-selected' : ''}`} onClick={() => handleButtonClick('branding')}>Branding</Button>
                            <Button type="button" className={`btnFilter ${selectedButton === 'print-graphics' ? 'is-selected' : ''}`} onClick={() => handleButtonClick('print-graphics')}>Print</Button>
                            <Button type="button" className={`btnFilter ${selectedButton === 'illustrations' ? 'is-selected' : ''}`} onClick={() => handleButtonClick('illustrations')}>Illustrations</Button>
                        </Col>
                    </Col >
                </Row>
                <Row className="mt-4 portfolioGrid" id="portfolioGrid">
                    <Col xs={12} className="grid">
                        <div className="grid-sizer"></div>
                        {renderProjects()}
                    </Col>
                </Row>
                <div className="detail" onClick={hideDetails}>
                    <img src='' alt=''/>
                    <div className="content">
                        <h3 className="title">Placehoder Title</h3>
                        <p className="description"></p>
                    </div>
                </div>
            </Container>
            <LetsTalk />
        </section>
        </div>
    )
}

export default Projects;